export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-01",
    q: "你们网站说的「吃瓜时间线」到底是什么？",
    a: "就是把一起复杂的网络热点事件，按时间发生的先后顺序整理成清晰的时间轴，讲清楚起因、经过、发酵和当前结果，帮你快速看懂整件事的前因后果，而不是只看到零散片段。",
  },
  {
    id: "faq-02",
    q: "事件信息可靠吗？平台是否持有立场？",
    a: "我们只对已公开流传的信息做整理与标注，明确区分「已确认信息」「双方说法」「尚未证实」三类，不对任何一方下结论，也不代表任何官方立场。涉及需要定性的部分，我们会注明信息来源与待证实状态。",
  },
  {
    id: "faq-03",
    q: "网站多久更新一次，信息会不会过期？",
    a: "热点事件通常在数小时内补充新节点；一旦事件有新进展、出现反转或有官方结论，我们会及时更新时间线，并在事件卡片上标注最近更新时间，方便你判断信息的新鲜度。",
  },
  {
    id: "faq-04",
    q: "我想追一起正在发酵的事件，该从哪看起？",
    a: "可以先在「今日热榜」里找到对应事件卡片快速浏览概览，再点击「展开完整时间线」查看起因与各阶段经过；正在发酵的事件我们会在状态栏标注「发酵中」，并持续为你补充后续节点。",
  },
];